module.exports = __webpack_public_path__ + "static/img/logo.c89a643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/logo.png
// module id = ThK+
// module chunks = 1